import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { endpoints } from "src/environments/environment";

import {
  AddressModelFmForm,
  AddressModelForm,
  ChangePasswordBody,
  CredentialModelForm,
  DocumentModelForm,
  PhoneModelForm,
  ProfileModelForm,
} from "../model/profile.model";

@Injectable({
  providedIn: "root",
})
export class ProfileService {
  CHANGE_PASSWORD = endpoints.change_password;
  CHANGE_MAIL = endpoints.change_mail;
  connect_user = endpoints.connect_user
  constructor(private http: HttpClient) { }

  connectUser() {
    return this.http.post(this.connect_user, {})
  }

  changeMail(changeMailRequest): Observable<any> {
    return this.http.post(this.CHANGE_MAIL, changeMailRequest);
  }

  changePassword(changePasswordRequest: ChangePasswordBody): Observable<any> {
    return this.http.post(this.CHANGE_PASSWORD, changePasswordRequest);
  }

  credentialScaffolding(): any {
    return of(CredentialModelForm);
  }

  getProfileFormScaffolding(): any {
    return of(ProfileModelForm);
  }

  getPhoneScaffolding(): any {
    return of(PhoneModelForm);
  }

  getDocScaffolding(): any {
    return of(DocumentModelForm);
  }

  getAddressScaffolding(): any {
    return of(AddressModelForm);
  }

  getAddressScaffoldingFm(): any {
    return of (AddressModelFmForm);
  }

}
